/*跨域地址*/
const dev = process.env.dev
const wxlogin = process.env.wxlogin

export default {
  /**更新token 微信公众号 */
  refreshToken: {
    url: wxlogin + '/wxmp/refresh',
    method: 'post'
  },
  /** 客户在微信公众号登录*/
  getUserToken: {
    url: wxlogin + '/noauth/login',
    method: 'post'
  },
  /**获取微信的token jsticket */
  getWechatToken: {
    url: wxlogin + '/wxmpweb/ticket',
    method: 'get'
  },
  /**发送短信 */
  getSmsCode: {
    url: dev + '/noauth/sms/send',
    method: 'post'
  },
  /**手机号码登录（H5环境） */
  getUserTokenByH5: {
    url: dev + '/noauth/h5/login',
    method: 'post'
  },
  /**H5刷新token */
  refreshTokenByH5: {
    url: dev + '/noauth/h5/refresh',
    method: 'post'
  },
  /**绑定手机号码（微信环境） */
  wxBind: {
    url: dev + '/bind',
    method: 'post'
  },
};



// WEBPACK FOOTER //
// ./src/api/service.js